export default __webpack_public_path__ + "50c780c0378e0c25ffb23b679e045448.png";